/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Lustrace_Page_TitleInputs */

const cs_lustrace_page_title = /** @type {(inputs: Lustrace_Page_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lustrace registrů`)
};

const en_lustrace_page_title = /** @type {(inputs: Lustrace_Page_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Registry checks`)
};

/**
* | output |
* | --- |
* | "Registry checks" |
*
* @param {Lustrace_Page_TitleInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const lustrace_page_title = /** @type {((inputs?: Lustrace_Page_TitleInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Lustrace_Page_TitleInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_lustrace_page_title(inputs)
	return cs_lustrace_page_title(inputs)
});